import { useQuery } from '@connectrpc/connect-query'

import type { CollectionRef as CollectionRefProto } from '@jotta/grpc-connect-openapi/collection'
import {
  countCollection,
  getCollection,
} from '@jotta/grpc-connect-openapi/collectionQuery'
import type { PartialMessage } from '@jotta/types/compat'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'

export type CollectionRef = PartialMessage<CollectionRefProto>
export type CollectionPhotoCount =
  | {
      count: number
      isExact: true
    }
  | {
      count: number
      isExact: false
    }

export function useCollection(collectionRef: CollectionRef) {
  return useQuery(
    getCollection,
    { collectionRef },
    {
      enabled: Boolean(collectionRef.ref?.case),
      select: data => data.result,
    },
  )
}

export function useCollectionPhotoCount(collectionRef: CollectionRef) {
  return useQuery(
    countCollection,
    { collectionRef },
    {
      enabled: Boolean(collectionRef.ref?.case),
      select: data => {
        switch (data.result.case) {
          case undefined:
            return undefined
          case 'photoCountExact':
            return {
              count: data.result.value,
              isExact: true,
            }
          case 'moreThan':
            return {
              count: data.result.value,
              isExact: false,
            }
          default:
            return exhaustiveGuard(data.result)
        }
      },
    },
  )
}

export function useAlbumId(collectionRef: CollectionRef) {
  const { data } = useCollection(collectionRef)
  switch (data?.case) {
    case undefined:
    case 'notFound':
      return undefined
    case 'collection':
      return data.value.albumId
    default:
      return exhaustiveGuard(data)
  }
}
